import { useEffect, useState } from "react";
import axios from "axios";
import "../../styles/pages/activities/RandomQuote.css";

export const TicTacToe = () => {
  return <div>Hello</div>;
};
